import confetti from "canvas-confetti";

/** Brief burst for a single item approved */
export function celebrateApproval() {
  confetti({
    particleCount: 40,
    spread: 60,
    origin: { y: 0.7 },
    colors: ["#00D68F", "#34D399", "#6EE7B7"],
    ticks: 120,
    gravity: 1.2,
    scalar: 0.9,
  });
}

/** Big celebration for all items completed */
export function celebrateAllComplete() {
  const end = Date.now() + 1500;

  (function frame() {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.6 },
      colors: ["#6C3BF5", "#00D68F", "#FBBF24", "#3B82F6"],
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.6 },
      colors: ["#6C3BF5", "#00D68F", "#FBBF24", "#3B82F6"],
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

/** Winner celebration with gold burst */
export function celebrateWin() {
  confetti({
    particleCount: 100,
    spread: 100,
    origin: { y: 0.5 },
    colors: ["#FBBF24", "#F59E0B", "#D97706", "#FDE68A"],
    ticks: 200,
    gravity: 0.8,
  });
}
